/**
 * Dependancies
 * @ignore
 * @internal
 */
import { Measurement } from 'types/general'
import * as Constants from './constants'

/**
 * Declare gauge display formulas. Every measurement
 * has different thresholds. These are calculated on the fly and we
 * basically define them here.
 */

// 
const gauges: Measurement = {
  in: {
    unit: ' '
  },
  out: {
    unit: ''
  },
  battery: {
    unit: '%',
    max: 100,
    min: 0
  },
  pm: {
    unit: 'ug/m3'
  },
  count: {
    unit: ' ',
    max: 20,
    min: 0,
    insight: () => {
      return Constants.STATUS.OK
    }
  },
  meeting_utilization: {
    unit: '%',
    max: 100,
    thresholdLow: 60,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  workspace_utilization: {
    unit: '%',
    max: 100,
    thresholdLow: 60,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  // We shouldn't use duplicates like this but will need a refactor to remove
  meetingUtilization: {
    unit: '%',
    max: 100,
    thresholdLow: 60,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  // We shouldn't use duplicates like this but will need a refactor to remove
  workspaceUtilization: {
    unit: '%',
    max: 100,
    thresholdLow: 60,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  occupancy: {
    unit: '%',
    max: 100,
    thresholdLow: 60,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  mic: {
    name: 'Soundscape',
    unit: 'dBA',
    max: 95,
    thresholdHigh: 70,
    insight: (val) => {
      switch (true) {
        case val > 70:
          return Constants.STATUS.ERROR
        case val > 60:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  soilTemp: {
    name: 'Soil Temperature',
    unit: '°C',
    

    insight: (val) => {
      switch (true) {
        case val > 30:
          return Constants.STATUS.WARNING
        case val < 10:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  soilMoisture: {
    name: 'Soil Moisture',
    unit: '%',
    insight: (val) => {
      switch (true) {
        case val > 50:
          return Constants.STATUS.WARNING
        case val < 25:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  nitrogen: {
    name: 'Nitrogen',
    unit: 'mg/kg',
    insight: (val) => {
      switch (true) {
        case val > 55:
          return Constants.STATUS.WARNING
        case val < 10:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  phosphorus:{
    name: 'Phosphorus',
    unit: 'mg/kg',
    insight: (val) => {
      switch (true) {
        case val > 60:
          return Constants.STATUS.WARNING
        case val < 10:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  potassium: {
    name: 'Potassium',
    unit: 'mg/kg',
    insight: (val) => {
      switch (true) {
        case val > 300:
          return Constants.STATUS.WARNING
        case val < 15:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  conductivity:{
    name: 'Conductivity',
    unit: 'µS/cm',
    insight: (val) => {
      switch (true) {
        case val > 1000:
          return Constants.STATUS.WARNING
        case val < 175:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  salinity:{
    name: 'Salinity',
    unit: 'µS/cm',
    insight: (val) => {
      switch (true) {
        case val > 1000:
          return Constants.STATUS.WARNING
        case val < 100:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  ph:{
    name: 'pH',
    unit: '',
    insight: (val) => {
      switch (true) {
        case val > 7.5:
          return Constants.STATUS.WARNING
        case val < 4.5:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  surfaceTemp:{
    name: 'Surface Temperature',
    unit: '°C',
    insight: (val) => {
      switch (true) {
        case val > 35:
          return Constants.STATUS.WARNING
        case val < 3:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  surfaceHumidity:{
    name: 'Surface Humidity',
    unit: '%',
    insight: (val) => {
      switch (true) {
        case val > 85:
          return Constants.STATUS.WARNING
        case val < 40:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  atmosPressure:{
    name: 'Atmospheric Pressure',
    unit: 'hPa',
    insight: (val) => {
      switch (true) {
        case val > 1035:
          return Constants.STATUS.WARNING
        case val < 995:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  dewPoint:{
    name: 'Dew Point',
    unit: '°C',
    //max: 30,
    insight: (val) => {
      switch (true) {
        case val > 18:
          return Constants.STATUS.WARNING
        case val < 0:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  windSpeed:{
    name: 'Wind Speed',
    unit: 'm/s',
    insight: (val) => {
      switch (true) {
        case val > 30:
          return Constants.STATUS.WARNING
        case val < 15:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  rainfall:{
    name: 'Rainfall',
    unit: 'mm',
    insight: (val) => {
      switch (true) {
        case val > 30:
          return Constants.STATUS.WARNING
        case val < 15:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  solarRadiation:{
    name: 'Solar Radiation',
    unit: 'W/m2',
    insight: (val) => {
      switch (true) {
        case val > 30:
          return Constants.STATUS.WARNING
        case val < 15:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  tds:{
    name: 'TDS',
    unit: '',
    
    insight: (val) => {
      switch (true) {
        case val > 30:
          return Constants.STATUS.WARNING
        case val < 15:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  temp: {
    name: 'Temperature',
    unit: '°C',
    max: 30,
    thresholdHigh: 28,
    thresholdLow: 22,
    insight: (val) => {
      switch (true) {
        case val > 28:
          return Constants.STATUS.ERROR
        case val > 25:
          return Constants.STATUS.WARNING
        case val < 22:
          return Constants.STATUS.WARNING
        case val < 20:
          return Constants.STATUS.ERROR
        default:
          return Constants.STATUS.OK
      }
    }
  },
  lux: {
    name: 'Light Levels',
    unit: 'lux',
    max: 400,
    thresholdHigh: 600,
    thresholdLow: 200,
    insight: (val) => {
      switch (true) {
        case val > 300:
          return Constants.STATUS.OK
        case val > 200:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  humidity: {
    name: 'Humidity',
    unit: '%',
    max: 80,
    thresholdHigh: 65,
    thresholdLow: 40,
    insight: (val) => {
      switch (true) {
        case val > 65:
          return Constants.STATUS.ERROR
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  tvoc: {
    name: 'Tvoc',
    unit: 'ppb',
    max: 300,
    thresholdHigh: 400,
    insight: (val) => {
      switch (true) {
        case val > 200:
          return Constants.STATUS.ERROR
        case val > 80:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  co2: {
    name: 'eCO2',
    unit: 'ppm',
    max: 1500,
    thresholdHigh: 1500,
    insight: (val) => {
      switch (true) {
        case val >= 1500:
          return Constants.STATUS.ERROR
        case val >= 800:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.OK
      }
    }
  },
  fixedAssets: {
    unit: '%',
    max: 100,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  mobileAssets: {
    unit: '%',
    max: 100,
    insight: (val) => {
      switch (true) {
        case val > 80:
          return Constants.STATUS.OK
        case val > 50:
          return Constants.STATUS.WARNING
        default:
          return Constants.STATUS.ERROR
      }
    }
  },
  massPm05: {
    unit: 'µg/m3',
    max: 25,
    thresholdHigh: 20,
    insight: () => {
      return Constants.STATUS.OK
    }
  },
  massPm1 : {
    unit: 'µg/m3',
    max: 70,
    insight: (val) => {
      if (val < 3.5) return Constants.STATUS.OK;
      if (val < 7) return Constants.STATUS.CONSIDERABLE;
      if (val < 10) return Constants.STATUS.DANGEROUS;
      return Constants.STATUS.ERROR;
    }
  },
  
  massPm10 : {
    name: 'Pm 10',
    unit: 'µg/m3',
    max: 150,
    insight: (val) => {
      if (val < 15) return Constants.STATUS.OK;
      if (val < 20) return Constants.STATUS.CONSIDERABLE;
      if (val < 30) return Constants.STATUS.DANGEROUS;
      return Constants.STATUS.ERROR;
    }
  },
  
  massPm25 : {
    name: 'Pm 2.5',
    unit: 'µg/m3',
    max: 75,
    insight: (val) => {
      if (val < 5) return Constants.STATUS.OK ;
      if (val < 10) return Constants.STATUS.CONSIDERABLE;
      if (val < 15) return Constants.STATUS.DANGEROUS;
      return Constants.STATUS.ERROR;
    }
  },
  
  massPm4 : {
    unit: 'µg/m3',
    max: 85,
    insight: (val) => {
      if (val < 8.5) return Constants.STATUS.OK;
      if (val < 17) return Constants.STATUS.CONSIDERABLE;
      if (val < 25) return Constants.STATUS.DANGEROUS;
      return Constants.STATUS.ERROR
    }
  },
  
  aqi: {
    unit: ' ',
    thresholdHigh: 4
  },
  
}

export default gauges
